<span *ngIf="lecon"> {{lecon.lecon}}
    <small> {{lecon.theme}} </small>
</span>